module.exports = __webpack_public_path__ + "static/media/plantFive.ca0db3b3.jpg";